import styled, { css, keyframes } from 'styled-components';
import { NotificationType } from './Notification.types';

const getNotifcationColor = (type: NotificationType) => {
  switch (type) {
    case 'info':
      return css`
        background: white;
        border-top: 1px;
        border-bottom: 1px;
        border-right: 1px;
        border-style: solid;
        border-color: rgba(255, 255, 255, 1);
        border-left: 4px solid rgba(32, 154, 214, 1);
      `;

    case 'error':
      return css`
        background: rgba(255, 240, 243, 1);
        border-top: 1px;
        border-bottom: 1px;
        border-right: 1px;
        border-style: solid;
        border-color: rgba(255, 224, 231, 1);
        border-left: 4px solid rgba(212, 63, 88, 1);
      `;

    case 'success':
      return css`
        background: rgba(220, 252, 232, 1);
        border-top: 1px;
        border-bottom: 1px;
        border-right: 1px;
        border-style: solid;
        border-color: rgba(198, 245, 214, 1);
        border-left: 4px solid rgba(0, 150, 78, 1);
      `;
    case 'warning':
      return css`
        background: rgba(255, 229, 214, 1);
        border-top: 1px;
        border-bottom: 1px;
        border-right: 1px;
        border-style: solid;
        border-color: rgba(255, 229, 214, 1);
        border-left: 4px solid rgba(250, 142, 65, 1);
      `;
    default:
      return css`
        background: rgba(230, 247, 255, 1);
        border-top: 1px;
        border-bottom: 1px;
        border-right: 1px;
        border-style: solid;
        border-color: rgba(209, 241, 255, 1);
        border-left: 4px solid rgba(32, 154, 214, 1);
      `;
  }
};

export const NotificationContainer = styled.div<{
  type: NotificationType;
  clientWidth: number;
  width?: string;
  marginLeft?: string;
  marginTop?: string;
  marginBottom?: string;
  fullWidth?: boolean;
}>`
  ${({ type }) => getNotifcationColor(type)};

  padding: 10px 16px;
  border-radius: 4px 4px 4px 4px;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: ${({ width }) => (width ? width : 'auto')};
  margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0px')};
  margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
  margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : '0px')};
  box-sizing: border-box;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);

  ${({ fullWidth, clientWidth }) =>
    fullWidth &&
    css`
      position: relative;

      // Centering the carousel in the middle of the screen with custom width.
      // In browser this should look something like this ->
      // width is eg.: 1713px
      // left: calc(50% - 856.5px);
      left: calc(50% - ${clientWidth / 2}px);
    `}
`;

export const NotificationBody = styled.div<{
  isMultiLine: boolean;
}>`
  display: flex;
  flex-direction: ${({ theme, isMultiLine }) =>
    isMultiLine ? 'column' : 'row'};
  align-items: ${({ theme, isMultiLine }) =>
    isMultiLine ? 'flex-start' : 'center'};
`;

export const NotificationTitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const NotificationTitle = styled.div`
  font-weight: 500;
  margin-left: 7px;
`;

export const NotificationIcon = styled.div``;

export const NotificationClose = styled.div`
  cursor: pointer;
`;

export const NotificationDescription = styled.div`
  color: ${({ theme }) => theme.palette.grey63};
  margin-left: 3px;
`;
